import { Gem, ShieldCheck, Feather, MoonStar } from "lucide-react";
import { FadeUp } from "@/components/Reveal";

const ITEMS = [
  [Gem, "Handmade, one by one", "Every bracelet is strung by Liza Zhen herself."],
  [MoonStar, "Simple prices", "Ready-made bracelets $5. Your own design $10."],
  [ShieldCheck, "Secure checkout", "Payments are handled safely by Stripe."],
  [Feather, "A place to be heard", "Sign in with Google to share your thoughts."],
];

export const Promises = () => (
  <section className="border-y border-purple-400/15 bg-[#170a24]" data-testid="promises-section">
    <div className="max-w-[1400px] mx-auto grid grid-cols-2 lg:grid-cols-4 gap-px bg-purple-400/15">
      {ITEMS.map(([Icon, title, text], i) => (
        <FadeUp key={title} delay={i * 0.08}
          className="bg-[#170a24] px-5 md:px-10 py-8 md:py-10">
          <div data-testid={`promise-${i}`}>
            <Icon className="w-6 h-6 text-amber-200" strokeWidth={1.5} />
            <p className="mt-4 md:mt-5 font-display text-xl md:text-2xl leading-tight">{title}</p>
            <p className="mt-2 text-sm text-purple-100/85 leading-relaxed">{text}</p>
          </div>
        </FadeUp>
      ))}
    </div>
  </section>
);
